import { ReactComponent as CloseLogo } from '@percent/cause-dashboard/common/assets/images/close.svg'
import styles from './PromotionalPopup.module.scss'
import { PromotionalPopupProps } from './PromotionalPopup.types'
import { MarketplaceBanner } from '@percent/cause-dashboard/app/productOffers/MarketPlaceBanner/MarketplaceBanner'
import { MarketplaceProgrammeVisitedSource } from '@percent/cause-dashboard/common/hooks/useCausesDashboardAnalytics/marketplaceAnalytics.types'
import { Box, Button, Modal } from '@percent/lemonade'

export function PromotionalPopup({ onClose, isOpened }: PromotionalPopupProps) {
  return (
    <Modal position="bottom-right" width={400} open={isOpened} data-testid="promo-popup">
      <Box className={styles.popupContentContainer}>
        <Box className={styles.closeButtonContainer}>
          <Button variant="tertiary" onClick={onClose} data-testid="promo-popup-close-button">
            <CloseLogo className={styles.closeButtonIcon} />
          </Button>
        </Box>
        <MarketplaceBanner
          forceMobileView={true}
          tracking={{
            source: MarketplaceProgrammeVisitedSource.Popup,
            programmeName: 'LinkedIn Fundraise'
          }}
        />
      </Box>
    </Modal>
  )
}
